import { Component, Injector, Input, OnInit } from '@angular/core';
import { BaseModalComponent } from '@card-software/library';
import { AssetType } from '../../../models/AssetType';
import { AssetPrefix } from '../../../models/AssetPrefix';
import { TypeProxyService } from '../../../proxies/asset/types.proxy.service';
import { PrefixProxyService } from '../../../proxies/asset/prefix.proxy.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AssetCategory } from '../../../models/AssetCategory';

@Component({
  selector: 'app-type-details-modal',
  templateUrl: './type-details-modal.component.html',
  styleUrl: './type-details-modal.component.scss',
})
export class TypeDetailsModalComponent extends BaseModalComponent<AssetType | null> implements OnInit {
  @Input() type: AssetType | null = null;
  @Input() categories: AssetCategory[] = [];

  availablePrefixes: AssetPrefix[] = [];

  name: FormControl<string | null> = new FormControl('', [Validators.required]);
  description: FormControl<string | null> = new FormControl('', [Validators.required]);
  assetCategoryReference: FormControl<string | null> = new FormControl('', [Validators.required]);
  assetPrefixReference: FormControl<string | null> = new FormControl('');
  assetProcesses: FormControl<[] | null> = new FormControl([]);
  createdBy: FormControl<string | null> = new FormControl('');
  modifiedBy: FormControl<string | null> = new FormControl('');
  modifiedDate: FormControl<Date> = new FormControl(new Date(), {
    nonNullable: true,
  });

  formTypeGroup: FormGroup = new FormGroup({
    name: this.name,
    description: this.description,
    assetCategoryReference: this.assetCategoryReference,
    assetPrefixReference: this.assetPrefixReference,
    assetProcesses: this.assetProcesses,
    createdBy: this.createdBy,
    modifiedBy: this.modifiedBy,
    modifiedDate: this.modifiedDate,
  });

  constructor(
    injector: Injector,
    private readonly typeProxyService: TypeProxyService,
    private readonly prefixProxyService: PrefixProxyService,
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.loadPrefixes();

    this.formTypeGroup.patchValue({
      id: this.type?.id || '',
      name: this.type?.name || '',
      description: this.type?.description || '',
      assetCategoryReference: this.type?.assetCategory?.id || this.type?.assetCategoryReference || '',
      assetPrefixReference: this.type?.assetPrefixReference || '',
      assetProcesses: this.type?.assetProcesses || [],
      createdBy: this.type?.createdBy || '',
      modifiedBy: this.type?.modifiedBy || '',
      modifiedDate: this.type?.modifiedDate || new Date(),
    });
  }

  loadPrefixes(): void {
    this.prefixProxyService.getPrefixes().subscribe((response) => {
      this.availablePrefixes = response.data || [];
    });
  }

  onClose() {
    this.close({ action: 'close', data: null });
  }

  onSave() {
    if (this.formTypeGroup.valid) {
      const currentDate = new Date();
      this.modifiedDate.setValue(currentDate);

      const type: AssetType = {
        id: this.type?.id ?? '',
        name: this.name.value ?? '',
        description: this.description.value ?? '',
        assetCategoryReference: this.assetCategoryReference.value ?? '',
        assetPrefixReference: this.assetPrefixReference.value ?? undefined,
        assetProcesses: this.assetProcesses.value ?? [],
        createdBy: this.createdBy.value ?? '',
        modifiedBy: this.modifiedBy.value ?? '',
        modifiedDate: currentDate,
      };

      this.typeProxyService.upsertType(type).subscribe((response) => {
        if (response.data) {
          this.close({ action: 'save', data: response.data });
        }
      });
    }
  }
}
